import type { IFileDownloadService } from "@/application/ports/services/IFileDownloadService";
import { downloadFromSignedUrl } from "@/infrastructure/api/fileDownload";

export class FileDownloadService implements IFileDownloadService {
  async downloadFromSignedUrl(signedUrl: string, filename: string): Promise<void> {
    return downloadFromSignedUrl(signedUrl, filename);
  }
}
